import React from "react"
import styled, { css, FlattenSimpleInterpolation } from "styled-components"

import { Color, LineHeight, RadiusSize, SpacingSize, TextSize } from "~/consts/style-mixins"

type FeedbackType = "attention" | "primary" | "secondary"
type Props = {
  messages?: string[]
  type: FeedbackType
  className?: string
}

const FeedbackMessage: React.FC<Props> = ({ messages, type, className, children }) => {
  return (
    <StyledContainer className={className} type={type}>
      {messages?.map((message, index) => {
        return <StyledText key={`key-${message}-${index}`}>{message}</StyledText>
      })}
      {children && <StyledText>{children}</StyledText>}
    </StyledContainer>
  )
}

export default FeedbackMessage

const StyledText = styled.p`
  font-size: ${TextSize.M}px;
  line-height: ${LineHeight.S}%;
`

const StyledContainer = styled.div<Pick<Props, "type">>`
  border-radius: ${RadiusSize.Small}px;
  padding: ${SpacingSize.M}px;
  ${({ type }) => StyleMapByFeedbackType[type]}
`

const StyleMapByFeedbackType: Record<FeedbackType, FlattenSimpleInterpolation> = {
  attention: css`
    border: 1px solid ${Color.Attention};
    color: ${Color.Attention};
    background-color: ${Color.BackgroundAttention};
  `,
  primary: css`
    border: 1px solid ${Color.Primary};
    color: ${Color.Primary};
    background-color: ${Color.BackgroundPrimary};
  `,
  secondary: css`
    border: 1px solid ${Color.Secondary};
    color: ${Color.Secondary};
    background-color: ${Color.BackgroundSecondary};
  `,
}
